import {
  PAN_CARD_UPDATE,
  UPDATE_IFSC_MUTUAL_FUND,
  VERIFY_BANK_DETAIL_MUTUAL_FUND,
  GIFT_SENT_SUCCESS,
  GIFT_SENT_FAIL,
  GIFT_INVESTMENT_FAIL,
  GIFT_INVESTMENT_SUCCESS,
  PURCHASE_DETAILS_FAIL,
  PURCHASE_DETAILS_SUCCESS,
  KYC_VERIFY_DETAILS,
  INVESTOR_CREATE_MUTUAL_FUND,
  INVESTMENT_CREATE_MUTUAL_FUND,
  GET_OTP_MUTUAL_FUND,
  KYC_CREATE_MUTUAL_FUND,
  UPLOAD_PHOTO_MUTUAL_FUND_DETAIL,
  UPDATE_ESIGN,
  GET_MUTUAL_FUND_KYC,
  ACTIVATE_KYC,
  SKIP_KYC,
  GET_MUTUAL_FUND_LIST
} from "./types";
import {
  API_BASE_URL,
  VERIFY_IFSC,
  VERIFY_PAN,
  BANK_VERIFY_MF,
  KYC_DETAILS_VERIFY_MF,
  MF_INVESTER_CREATE,
  MF_INVESTMENT_CREATE,
  KYC_OTP,
  CREATE_KYC,
  MF_DOCUMENTAPI,
  ESIGN_MF,
  MF_KYC_STATUS,
  ACTIVATE_MF,
  MF_SKIP_KYC,MF_AMC_LIST
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "../../models";
/**************************************Login ****************************************************/

export function verifyPAN(req: Models.VerifyPANRequest, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: PAN_CARD_UPDATE });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + VERIFY_PAN, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function verifyIFSC(req: Models.VerifyIFSC, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_IFSC_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + VERIFY_IFSC, req, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function verifyBankMutualFund(
  req: Models.VerifyBankDetailMutualFundRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: VERIFY_BANK_DETAIL_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + BANK_VERIFY_MF, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function userKycVerifyDetails(
  req: Models.MFKYCDetailVerifyRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: KYC_VERIFY_DETAILS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            API_BASE_URL + KYC_DETAILS_VERIFY_MF,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function createInvestorMutualFund(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: INVESTOR_CREATE_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            API_BASE_URL + MF_INVESTER_CREATE,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function createInvestmentMutualFund(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: INVESTMENT_CREATE_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            API_BASE_URL + MF_INVESTMENT_CREATE,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getOtpMutualFund(req: Models.MFKYCOTPREQUEST, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_OTP_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + KYC_OTP, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function createKycForMF(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: KYC_CREATE_MUTUAL_FUND });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + CREATE_KYC, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function uploadDocumentMF(req: FormData, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: UPLOAD_PHOTO_MUTUAL_FUND_DETAIL });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .uploadData(API_BASE_URL + MF_DOCUMENTAPI, req, token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function updateEsign(req: Models.ESignRequest, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_ESIGN });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + ESIGN_MF, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function getKYCStatus(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_KYC });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_KYC_STATUS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function activateKYC(
  req: Models.MutualFundKYCRequestStatus,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: ACTIVATE_KYC });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + ACTIVATE_MF, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function skipMFKYC(
  req: Models.SkipKycMutualFundRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: SKIP_KYC });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
        .postData(API_BASE_URL+ MF_SKIP_KYC, JSON.stringify(req), token)
        .then((response: any) => {
          let result = response;
          getInvestmentSuccess(dispatch, result);
          resolve(result);
        })
        .catch((error: any) => {
          let errorMessage = error.message;
          getInvestmentFailed(dispatch, errorMessage);
          reject(errorMessage);
        });
      }
    });
}


export function getAMCList(req:any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND_LIST });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_AMC_LIST, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

const getSentSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: GIFT_SENT_SUCCESS,
    payload: message,
  });
};

const getSentFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_SENT_FAIL,
    payload: errorMessage,
  });
};
const getInvestmentFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_FAIL,
    payload: errorMessage,
  });
};
const getInvestmentSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_SUCCESS,
    payload: errorMessage,
  });
};

const getSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  message: any
) => {
  dispatch({
    type: PURCHASE_DETAILS_SUCCESS,
    payload: message,
  });
};

const getFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: PURCHASE_DETAILS_FAIL,
    payload: errorMessage,
  });
};
